import { Moon, Sun } from 'lucide-react';
import { useThemeStore } from '../../stores/theme-store';

export function ThemeToggle() {
  const dark = useThemeStore((s) => s.dark);
  const toggle = useThemeStore((s) => s.toggle);

  return (
    <button
      onClick={toggle}
      className="group inline-flex h-10 items-center gap-2 rounded-full border border-[color:var(--surface-line)] bg-[var(--surface-panel)] px-2.5 pr-3 text-xs font-semibold uppercase tracking-[0.14em] text-[color:var(--ink-soft)] shadow-[var(--shadow-soft)] transition-all duration-200 hover:border-[color:var(--surface-line-strong)] hover:text-[color:var(--ink-strong)]"
      aria-label={dark ? 'Mod luminos' : 'Mod întunecat'}
    >
      <span className="grid h-6 w-6 place-items-center rounded-full bg-[color:color-mix(in_oklab,var(--color-accent)_15%,var(--surface-panel-strong))] text-[color:var(--ink-strong)] transition-transform duration-200 group-hover:rotate-6">
        {dark ? <Sun size={15} /> : <Moon size={15} />}
      </span>
      <span className="hidden sm:inline">{dark ? 'Intunecat' : 'Luminos'}</span>
    </button>
  );
}
